import { airportLabel, airportSwitchOf } from '@voll-intelligence/genui-contract';
import type { TripStop } from './derive.js';
import { t } from './i18n.js';

/**
 * A volta deste bilhete parte de um aeroporto diferente daquele em que a ida
 * chega (#4203: ida CNF → CGH, volta GRU → CNF)? Só a PRIMEIRA perna da volta
 * responde, contra a ÚLTIMA da ida do mesmo serviço. A frase é a última chance
 * de a pessoa perceber enquanto ainda dá para trocar — "São Paulo" embaixo dos
 * dois códigos não desempata.
 */
export function ReturnAirportSwitch({ stop }: Readonly<{ stop: TripStop }>) {
  const leg = stop.leg;
  const detail = stop.service.detail;
  if (leg?.leg !== 'volta' || detail?.kind !== 'FLIGHT') return null;
  if (detail.legs.find((l) => l.leg === 'volta')?.key !== leg.key) return null;
  const found = airportSwitchOf({
    outboundArrival: detail.legs.filter((l) => l.leg === 'ida').at(-1)?.to,
    returnDeparture: leg.from,
  });
  if (!found) return null;
  return (
    <span className="tp-stop__sub text-detail font-medium text-warning-strong">
      {t('trips.panel.returnAirportSwitch', {
        departure: airportLabel(found.returnDeparture),
        arrival: airportLabel(found.outboundArrival),
      })}
    </span>
  );
}
